module.exports = __webpack_public_path__ + "static/memory-card-bg-715dad4786cbca4d98d9916e648f689f.svg";